import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface GeolocationConfigModel extends ComponentBaseConfigModel {
  noTimeout: boolean;
}
